module.exports = __webpack_public_path__ + "media/start.c18f1bfb.ogg";